import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CheckCircle, ArrowLeft, Clock, Users } from "lucide-react";
import Navbar from "../../components/Navbar";

export default function CourseDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const course = location.state?.course;

  if (!course) return <div className="mt-20 text-center">Course not found</div>;

  return (
    <>
      <Navbar />
      <div className="mt-20 min-h-screen bg-white pb-20">
        {/* HERO SECTION WITH VIDEO */}
        <div className="bg-slate-900 py-12 px-4">
          <div className="max-w-5xl mx-auto grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-blue-400 mb-6 font-bold hover:text-white transition-colors">
                <ArrowLeft size={18} /> Back to Recommendations
              </button>
              <h1 className="text-3xl md:text-5xl font-black text-white leading-tight mb-4">{course.title}</h1>
              <p className="text-slate-300 text-lg mb-6">{course.description}</p>
              <div className="flex gap-6 text-white/80">
                <div className="flex items-center gap-2"><Clock size={18}/> {course.duration}</div>
                <div className="flex items-center gap-2"><Users size={18}/> {course.students} Students</div>
              </div>
            </div>
            
            {/* YOUTUBE EMBED */}
            <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10">
              <iframe
                width="100%"
                height="100%"
                src={course.videoUrl}
                title="Course Preview"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>

        {/* DETAILS SECTION */}
        <div className="max-w-5xl mx-auto px-4 py-12">
          <div className="grid md:grid-cols-3 gap-12">
            <div className="md:col-span-2">
              <h2 className="text-2xl font-black mb-6">Requirements</h2>
              <div className="grid gap-4">
                {course.requirements.map((req, index) => (
                  <div key={index} className="flex items-start gap-3 p-4 bg-slate-50 rounded-xl border border-slate-100">
                    <CheckCircle className="text-green-500 mt-1 shrink-0" size={20} />
                    <span className="text-slate-700 font-medium">{req}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* SIDEBAR ENROLL */}
            <div className="bg-white border-2 border-slate-100 p-8 rounded-3xl h-fit shadow-xl sticky top-28">
               <p className="text-slate-400 font-bold uppercase text-[10px] tracking-widest mb-1">Total Investment</p>
               <h3 className="text-4xl font-black mb-6">{course.price}</h3>
               <button className="w-full bg-blue-600 text-white py-4 rounded-xl font-black uppercase tracking-widest hover:bg-blue-700 transition-all shadow-lg shadow-blue-200">
                 Enroll Now
               </button>
              
            </div>
          </div>
        </div>
      </div>
    </>
  );
}